import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <AboutSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <ContactSection />
        <FaqSection />
        <UpdatesSection />
        <RankingSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}